import isObject from 'lodash/isObject';
import forEach from 'lodash/forEach';

/**
 * @method camelize
 * Convert string to camelCase
 * @param {String} str String for camelizing
 * @returns {String} String in camelCase format
 */
export function camelize(str) {
  return str
    ?.replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) => (index === 0 ? letter.toLowerCase() : letter.toUpperCase()))
    .replace(/\s+/g, '');
}

/**
 * @method decamelize
 * Convert string from camelCase to normal format
 * @param {String} str String for decamelizing
 * @returns {String} String in normal format
 */
export function decamelize(str) {
  return str.replace(/(?:^\w|[A-Z])/g, (letter, index) => (index === 0 ? letter.toUpperCase() : ` ${letter}`));
}

/**
 * @method mapObject
 * Assign {iterator} function to each property of {obj}
 * @param {Object} obj
 * @param {Function} iterator
 * @returns {Object|*} Returns object with properties name in camelCase
 */
export function mapObject(obj, iterator) {
  const result = {};
  if (!obj || !isObject(obj)) {
    return obj;
  }
  forEach(obj, (value, key) => {
    result[iterator(key)] = value;
  });

  return result;
}

/**
 * @method camelizeObject
 * Camelize all property's names in object
 * @param obj
 * @returns {Object|*}
 */
export function camelizeObject(obj) {
  return mapObject(obj, camelize);
}

/**
 * @method camelizeObject
 * Decamelize all property's names in object
 * @param obj
 * @returns {Object|*}
 */
export function decamelizeObject(obj) {
  return mapObject(obj, decamelize);
}
